import React from 'react';
import { Box, Icon, BoxProps, Body, Divider } from '@hover/blueprint';
import { IconProp } from '@hover/icons';

interface Props extends BoxProps {
  iconName: IconProp;
  title: string;
  body: string;
}

const JobBenefit: React.FC<Props> = ({
  iconName,
  title,
  body,
  ...restProps
}) => (
  <Box flexDir="column">
    <Box alignItems="flex-start" {...restProps} py={600}>
      <Box
        w={400}
        h={400}
        minW={400}
        borderRadius="50%"
        bg="primary.100"
        alignItems="center"
        justifyContent="center"
        mr="27px"
      >
        <Icon icon={iconName} color="primary.600" m={0} size="large" />
      </Box>
      <Box flexDir="column">
        <Body mb={200} isBold>
          {title}
        </Body>
        <Body>{body}</Body>
      </Box>
    </Box>
    <Divider
      borderColor="neutral.400"
      borderWidth={0}
      borderTopWidth="1px"
      my={0}
    />
  </Box>
);

export default JobBenefit;
